export const images = [
  { id: 1, original: "/images/services/2/sub-categories/4/c2-s4-p1.jpg" },
];
